module.exports = {
  description: 'All about the 2020/21 UEFA Champions League Final.',
  title: '2020/21 UCL FINAL',
  vodCount: 15,
  coverUrl:
    'https://dve-images.imggaming.com/original/p/2021/05/27/it6lLYReY3ez5IhpjoDZdQbjA0VezQ9S-1622149620889.jpeg',
  smallCoverUrl:
    'https://dve-images.imggaming.com/original/p/2021/05/27/AOcxhhUYYG9ACyEJoRABTyTHo8E9l4Py-1622149605487.jpeg',
  id: 6793,
  vods: [
    {
      description: "Go behind the scenes at the season's UEFA Champions League final in our spectacular short film.",
      duration: 747,
      title: '2020/21 #UCL Final: Official Film',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/06/09/vgGjU3HxN0V6c5tTgLi2ey1CtZReltal-1623198952837.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 228984,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '228984:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/06/08/i4d2yezyOaWu6NmBwaWcqEOlmCKQRSzW-1623157445810/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: 'Watch the full match of Chelsea’s victory over Man. City in the UEFA Champions League final.',
      duration: 7316,
      title: 'Match re-run: Man. City 0-1 Chelsea',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/30/hZ9rgx3lDpv9nxKV4kFloDtV256UrVee-1622409108887.jpeg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 226569,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: 'UCL_20239_2029498',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/30/efFFdIGHvIQ8fYzCBAa4jlcr2W9n96ov-1622405071393/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: "See how Chelsea claimed Champions League glory in Porto thanks to Kai Havertz's first-half strike.",
      duration: 120,
      title: 'Highlights: Man. City 0-1 Chelsea',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/29/IJV40uAEB4474gQDAlGDcpy569puyhtb-1622325792118.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 226519,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10204216004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/29/V8kQ9Sq1WQavY0wFULBvRyf0aEI0rMVX-1622325939414/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description:
        "Chelsea's Thomas Tuchel is the third German coach to lift the Champions League trophy in succession - recap these and all the others down the years.",
      duration: 157,
      title: 'UCL Winners: German managers',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/30/dU6lqBEiCC9Ion3Y2YVoP3magWInrtdK-1622409065816.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 226521,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '226521:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/29/zu2FSI3MDr862WUOJ2kntW0ofvRRXYwV-1622328378720/bif/preview_thumbnails.bif',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: 'Watch Marshmello plus special guests perform at the #UCLFinal Opening Ceremony presented by Pepsi.',
      duration: 366,
      title: '#UCL Final Opening Ceremony with Marshmello',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/29/Ri2DN8vpIxdFBnAJ91z3mciBNmdgRuqW-1622292365215.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 226307,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '226307:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/29/qvM4l307Hp48wDTasUS6PqRpIvFPMmd6-1622289610249/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description:
        'We hear from Mason Mount, John Stones, Kai Havertz and Kevin De Bruyne, plus a host of other Chelsea and Man. City stars, ahead of the 2020/21 UEFA Champions League final.',
      duration: 93,
      title: 'UEFA Champions League final: Preview',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/27/4jpbjUeNAslvD2uQ9qfMTE8hvubbEkKk-1622149696501.jpeg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 225010,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10196462004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/24/enb0lkIc550rOrSQBPhs5PgK1oW5dMwW-1621866686240/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: 'We look back on the most noteworthy statistics and numbers from the 2020/21 season.',
      duration: 117,
      title: 'Stat Attack: The Story So Far',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/18/s5CtOtpCOQrN5HqeMohg3xFnE8IHPEbF-1621337643491.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 223361,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10188031004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/17/gekzNW06oxzTsBGjrKDAmslxhmVDcUQx-1621271345437/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description:
        "In this week's show, we look at the history of Manchester City in the UEFA Champions League, from their debut to this weekend's final against Chelsea.",
      duration: 1363,
      title: 'UCL Weekly Magazine Show #31',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/21/VD24cS5OTcjG7xTcDJa20CrRsNfGbtts-1621612278765.jpeg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 224084,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10193580004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/21/HzOg0HXLRWTrqG0ZzjnAydbnM9IKyGH5-1621611168728/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description:
        'This week, we look back at the history of Chelsea in the UEFA Champions League, as they prepare to play in their third final.',
      duration: 1380,
      title: 'UCL Weekly Magazine Show #30',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/14/COJtpxbZlWpf5Eiia5AnQSGghYOJJgzK-1621003086385.jpeg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 222912,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10184413004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/14/mo2eifD5BMHX5Pr4F6TeLZssFjoWJYGP-1620997845533/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: 'Manchester City will face Chelsea in an eighth one-nation UEFA Champions League final.',
      duration: 128,
      title: 'One-nation Champions League finals',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/06/8Lu7sAPss54HOZpqwZuNMx1UYz47ia87-1620284871702.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 220821,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '220821:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/05/MKed6diMlOODYm2N6IOBGpUAOixKm3Nz-1620254631492/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description: 'Enjoy some of the best action from all-English knockout ties in the Champions League.',
      duration: 182,
      title: 'Best Of: All-English Knockout Ties',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/18/a7BplV4xblwkMUsuEfmzsWqQdWOSvOOs-1621346971206.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 223368,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10188024004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/17/mln9lxnXu8oWu3v9dsPwbG0au3DjsWrB-1621271607183/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
    {
      description:
        "We look at some of the all-time best goals scored by this season's Champions League finalists, Manchester City and Chelsea.",
      duration: 183,
      title: 'Classic Goals: Man. City & Chelsea',
      contentDownload: {
        permission: 'DISALLOWED',
      },
      favourite: false,
      thumbnailUrl:
        'https://dve-images.imggaming.com/original/p/2021/05/18/huiI7zhtcJfFfkOi7TrDEtev83db31Ky-1621346693714.jpg',
      offlinePlaybackLanguages: [],
      availableOnSignInLicences: [],
      id: 223369,
      type: 'VOD',
      accessLevel: 'GRANTED',
      availablePurchases: [],
      externalAssetId: '10188023004:UCL',
      subEvents: [],
      maxHeight: 1080,
      thumbnailsPreview:
        'https://dve-images.imggaming.com/original/p/2021/05/17/Tcg0mgMdfcgGbW90Kars2kBCKeXyp9oM-1621271654887/bif/preview_thumbnails.bif',
      longDescription: 'Missing translation',
      categories: [''],
      computedReleases: [],
      playbackType: 'ON_DEMAND',
      onlinePlayback: 'AVAILABLE',
    },
  ],
  upcomingReleases: [],
};
